import { createContext, useContext, useMemo } from 'react'
import { Box } from '@material-ui/core'
import ManagementAccountantsNPSSection from 'components/Management/ManagementAccountants/ManagementAccountantsNPSSection/ManagementAccountantsNPSSection'
import ManagementAccountantsTable from 'components/Management/ManagementAccountants/ManagementAccountantsTable/ManagementAccountantsTable'
import useManagementAccountantsContainer, {
  IUseManagementAccountantsContainer,
} from './useManagementAccountantsContainer'

export const ManagementAccountantsContainerContext =
  createContext<IUseManagementAccountantsContainer | null>(null)

const ManagementAccountantsContainer = () => {
  const managementAccountantsState = useManagementAccountantsContainer()

  const memoizedContextValue: IUseManagementAccountantsContainer = useMemo(
    () => managementAccountantsState,
    [managementAccountantsState]
  )

  return (
    <div className="management-accountants-container">
      <ManagementAccountantsContainerContext.Provider
        value={memoizedContextValue}>
        <Box marginY={8}>
          <ManagementAccountantsNPSSection />
          <ManagementAccountantsTable />
        </Box>
      </ManagementAccountantsContainerContext.Provider>
    </div>
  )
}

export const useManagementAccountantsContainerContext = () => {
  const context = useContext(ManagementAccountantsContainerContext)

  if (!context) {
    throw new Error(
      'useManagementAccountantsContainerContext must be used within a ManagementAccountantsContainerContext'
    )
  }

  return context
}

export default ManagementAccountantsContainer
